export default "__VITE_ASSET__76d47b15__"